const SESSION_REGISTRATION_SLUG = 'the-session-2027'

export function getRegistrationOptionHighlight(
  conventionSlug: string,
  description: string | null | undefined
): string | null {
  if (conventionSlug.toLowerCase() !== SESSION_REGISTRATION_SLUG) return null

  const normalizedDescription = description?.trim().toLowerCase() ?? ''

  if (normalizedDescription.includes('vip')) {
    return 'Includes two workshops worth £120, priority seating and priority registration.'
  }

  if (normalizedDescription.includes('standard')) {
    return 'Includes all three days of performances, lectures, the Gala show and dealer showcases.'
  }

  return null
}
